import axios from 'axios'
import { Message } from 'element-ui'
import Vue from 'vue'


// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;

function startLoading() {
    loading = Vue.prototype.$loading({
        lock: true,
        text: 'Loading...',
        background: 'rgba(255, 255, 255, 0.9)',
        target: document.querySelector('.loading-area') //设置加载动画区域
    });
}

function endLoading() {
    loading.close();
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }
    needLoadingRequestCount++;
};

function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
        endLoading();
    }
};

//  请求拦截
axios.interceptors.request.use(config => {
    showFullScreenLoading();
    return config;
}, err => {
    tryHideFullScreenLoading();
    Message.error({ message: '请求超时!' });
    return Promise.resolve(err);
})

//  响应拦截
axios.interceptors.response.use(res => {
    tryHideFullScreenLoading();
    if (res.status == 200) {
        // console.log('axios', res.data)
        return res;
    }
    return Promise.reject(res);
}, err => {
    tryHideFullScreenLoading();
    return Promise.reject(err);
})

export default function ajax(url, data = {}, type = 'GET') {
    return new Promise(function(resolve, reject) {
        // 执行异步ajax请求
        let promise
        if (type === 'GET') {
            // 准备url query参数数据
            let dataStr = '' //数据拼接字符串
            Object.keys(data).forEach(key => {
                dataStr += key + '=' + data[key] + '&'
            })
            if (dataStr !== '') {
                dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
                url = url + '?' + dataStr
            }
            // 发送get请求
            promise = axios.get(url)
        } else {
            // 发送post请求

            let dataStr = '' //数据拼接字符串
            Object.keys(data).forEach(key => {
                dataStr += key + '=' + data[key] + '&'
            })
            if (dataStr !== '') {
                dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
                url = url + '?' + dataStr

                promise = axios.post(url)
            } else {
                promise = axios.post(url, data)
            }

            // promise = axios.post(url, data)
        }
        promise.then(function(response) {
            // 成功了调用resolve()
            resolve(response.data)
        }).catch(function(error) {
            //失败了调用reject()
            reject(error)
        })
    })
}


// WEBPACK FOOTER //
// ./src/api/ajax.js